var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"simple-nav d-flex mb-5 flex-wrap"},[_vm._l((_vm.options),function(option,i){return [_c('button',{key:i,class:{
          'text-secondary': _vm.value !== option.id,
          'text-primary font-weight-bold': _vm.value === option.id
        },on:{"click":function($event){return _vm.$emit('input', option.id)}}},[_vm._v(" "+_vm._s(option.name)+" ")])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }